import { render, staticRenderFns } from "./CardPayIcon.vue?vue&type=template&id=1f63b9c5&"
import script from "./CardPayIcon.vue?vue&type=script&lang=js&"
export * from "./CardPayIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports